if (!customElements.get('ms-product-hotspots')) {
  customElements.define('ms-product-hotspots', class extends HTMLElement {
    connectedCallback() {
      this.mediaQuery = window.matchMedia('(max-width: 767px)');
      this.features = Array.from(this.querySelectorAll('.ms-pdp-feature'));
      this.updateLayout = () => this.features.forEach((feature, index) => {
        feature.open = !this.mediaQuery.matches || index === 0;
      });
      this.onMarkerClick = (event) => {
        const marker = event.target.closest('.ms-pdp-hotspot');
        if (!marker) return;
        const feature = this.features.find(item => `#${item.id}` === marker.getAttribute('href'));
        if (feature) feature.open = true;
      };
      this.updateLayout();
      this.mediaQuery.addEventListener('change', this.updateLayout);
      this.addEventListener('click', this.onMarkerClick);
    }
    disconnectedCallback() {
      this.mediaQuery?.removeEventListener('change', this.updateLayout);
      this.removeEventListener('click', this.onMarkerClick);
    }
  });
}

if (!customElements.get('ms-product-strip')) {
  customElements.define('ms-product-strip', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.ms-pdp-strip-grid');
      this.previous = this.querySelector('[data-strip-prev]');
      this.next = this.querySelector('[data-strip-next]');
      this.count = this.querySelector('[data-strip-count]');
      this.updateProgress = () => {
        const itemWidth = this.grid.firstElementChild?.getBoundingClientRect().width || this.grid.clientWidth;
        const gap = parseFloat(getComputedStyle(this.grid).columnGap) || 0;
        const visible = Math.max(1, Math.round((this.grid.clientWidth + gap) / (itemWidth + gap)));
        const total = Math.max(1, Math.ceil(this.grid.children.length / visible));
        this.pageWidth = visible * (itemWidth + gap);
        const page = Math.min(total, Math.round(this.grid.scrollLeft / this.pageWidth) + 1);
        this.style.setProperty('--strip-progress', `${page / total * 100}%`);
        this.count.textContent = `${String(page).padStart(2, '0')} / ${String(total).padStart(2, '0')}`;
        this.previous.disabled = this.grid.scrollLeft <= 1;
        this.next.disabled = this.grid.scrollLeft + this.grid.clientWidth >= this.grid.scrollWidth - 1;
      };
      this.onNavigation = (event) => {
        const direction = event.target.closest('[data-strip-prev]') ? -1 : event.target.closest('[data-strip-next]') ? 1 : 0;
        if (direction) this.grid.scrollBy({ left: direction * this.pageWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.addEventListener('click', this.onNavigation);
      this.grid.addEventListener('scroll', this.updateProgress, { passive: true });
      this.resizeObserver = new ResizeObserver(this.updateProgress);
      this.resizeObserver.observe(this.grid);
      this.updateProgress();
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.grid?.removeEventListener('scroll', this.updateProgress);
      this.removeEventListener('click', this.onNavigation);
    }
  });
}
